<template>
    <main-content with_go_back_bar>
        <div>
            <kt-panel>
                <users-club-events-filter :action="filterAction"></users-club-events-filter>
                <kt-datatable v-bind="datatableProps" ref="datatable"></kt-datatable>
            </kt-panel>
        </div>
    </main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import {ApiUrl} from '@/common/api.service'
import {AuthorizationHeader} from '@/common/jwt.service'
import columns from "./datatable/columns";
import usersClubEventsFilter from "./components/users-club-events-filter";

export default {
    components: {
        'main-content': mainContent,
        usersClubEventsFilter
    },
    data() {
        return {
            headerAction: {
                left: '10px',
                top: '10px',
                position: 'absolute'
            },
            query: {}
        }
    },
    computed: {
        datatableProps() {
            return {
                id: "users_club_events_datatable",
                data: {
                    type: 'remote',
                    source: {
                        read: {
                            url: ApiUrl.path('customers-club/events'),
                            method: 'GET',
                            headers: AuthorizationHeader,
                            map: (res) => {
                                return res.data.data
                            },
                            params: {
                                query: this.query
                            },
                        }
                    },
                    pageSize: 15,
                    serverPaging: true,
                    serverFiltering: true,
                    serverSorting: true,
                },

                pagination: false,
                sortable: true,
                columns: columns,
            }
        },
    },
    methods:{
        filterAction(e, query) {
            this.query = query
            if (this.$refs.datatable.KTDatatable) {
                this.$refs.datatable.reload()
            }
        }
    }
}
</script>